import {CardEnum, TileCornerBuildingType, TileHexType} from '@colonist/game-states'

export abstract class ProductionController {
    abstract settlementLumberProduction: CardEnum[]
    abstract settlementBrickProduction: CardEnum[]
    abstract settlementWoolProduction: CardEnum[]
    abstract settlementGrainProduction: CardEnum[]
    abstract settlementOreProduction: CardEnum[]
    abstract settlementGoldProduction: CardEnum[]
    abstract settlementSeaProduction: CardEnum[]
    abstract settlementDesertProduction: CardEnum[]
    abstract settlementFogProduction: CardEnum[]

    abstract cityLumberProduction: CardEnum[]
    abstract cityBrickProduction: CardEnum[]
    abstract cityWoolProduction: CardEnum[]
    abstract cityGrainProduction: CardEnum[]
    abstract cityOreProduction: CardEnum[]
    abstract cityGoldProduction: CardEnum[]
    abstract citySeaProduction: CardEnum[]
    abstract cityDesertProduction: CardEnum[]
    abstract cityFogProduction: CardEnum[]

    getProductionForCornerPieceAndTile(cornerBuilding: TileCornerBuildingType, tileType: TileHexType): CardEnum[] {
        switch(cornerBuilding) {
            case TileCornerBuildingType.KnightActiveLevel1:
            case TileCornerBuildingType.KnightActiveLevel2:
            case TileCornerBuildingType.KnightActiveLevel3:
            case TileCornerBuildingType.KnightInactiveLevel1:
            case TileCornerBuildingType.KnightInactiveLevel2:
            case TileCornerBuildingType.KnightInactiveLevel3: return []
            case TileCornerBuildingType.DestroyedCity:
            case TileCornerBuildingType.Settlement: return this.getProductionForSettlement(tileType)
            case TileCornerBuildingType.City: return this.getProductionForCity(tileType)
        }
    }

    private getProductionForSettlement(tileType: TileHexType): CardEnum[] {
        switch(tileType) {
            case TileHexType.Lumber: return this.settlementLumberProduction
            case TileHexType.Brick: return this.settlementBrickProduction
            case TileHexType.Wool: return this.settlementWoolProduction
            case TileHexType.Grain: return this.settlementGrainProduction
            case TileHexType.Ore: return this.settlementOreProduction
            case TileHexType.Gold: return this.settlementGoldProduction
            case TileHexType.Sea: return this.settlementSeaProduction
            case TileHexType.Desert: return this.settlementDesertProduction
            case TileHexType.Fog: return this.settlementFogProduction
        }
    }

    private getProductionForCity(tileType: TileHexType): CardEnum[] {
        switch(tileType) {
            case TileHexType.Lumber: return this.cityLumberProduction
            case TileHexType.Brick: return this.cityBrickProduction
            case TileHexType.Wool: return this.cityWoolProduction
            case TileHexType.Grain: return this.cityGrainProduction
            case TileHexType.Ore: return this.cityOreProduction
            case TileHexType.Gold: return this.cityGoldProduction
            case TileHexType.Sea: return this.citySeaProduction
            case TileHexType.Desert: return this.cityDesertProduction
            case TileHexType.Fog: return this.cityFogProduction
        }
    }
}

export class ClassicResourceProductionController extends ProductionController {
    settlementLumberProduction = [CardEnum.Lumber]
    settlementBrickProduction = [CardEnum.Brick]
    settlementWoolProduction = [CardEnum.Wool]
    settlementGrainProduction = [CardEnum.Grain]
    settlementOreProduction = [CardEnum.Ore]
    settlementGoldProduction = []
    settlementSeaProduction = []
    settlementDesertProduction = []
    settlementFogProduction = []

    cityLumberProduction = [CardEnum.Lumber, CardEnum.Lumber]
    cityBrickProduction = [CardEnum.Brick, CardEnum.Brick]
    cityWoolProduction = [CardEnum.Wool, CardEnum.Wool]
    cityGrainProduction = [CardEnum.Grain, CardEnum.Grain]
    cityOreProduction = [CardEnum.Ore, CardEnum.Ore]
    cityGoldProduction = []
    citySeaProduction = []
    cityDesertProduction = []
    cityFogProduction = []
}

export class CommodityResourceProductionController extends ProductionController {
    settlementLumberProduction = [CardEnum.Lumber]
    settlementBrickProduction = [CardEnum.Brick]
    settlementWoolProduction = [CardEnum.Wool]
    settlementGrainProduction = [CardEnum.Grain]
    settlementOreProduction = [CardEnum.Ore]
    settlementGoldProduction = []
    settlementSeaProduction = []
    settlementDesertProduction = []
    settlementFogProduction = []

    cityLumberProduction = [CardEnum.Lumber, CardEnum.Paper]
    cityBrickProduction = [CardEnum.Brick, CardEnum.Brick]
    cityWoolProduction = [CardEnum.Wool, CardEnum.Cloth]
    cityGrainProduction = [CardEnum.Grain, CardEnum.Grain]
    cityOreProduction = [CardEnum.Ore, CardEnum.Coin]
    cityGoldProduction = []
    citySeaProduction = []
    cityDesertProduction = []
    cityFogProduction = []
}

